var _style, _defs, _rect, _defs2, _rect2, _defs3, _rect3, _defs4, _rect4, _defs5, _rect5, _defs6, _rect6, _defs7, _rect7, _defs8, _rect8, _defs9, _rect9, _defs10, _rect10, _defs11, _rect11, _rect12, _rect13, _defs12, _rect14, _defs13, _rect15, _defs14, _rect16, _defs15, _rect17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMercadolibre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 683 514.1",
    style: {
      enableBackground: "new 0 0 683 514.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000093886867244984725920000014086951627988031147_);}\r\n\t.st1{fill:#334155;}\r\n\t.st2{clip-path:url(#SVGID_00000104706199260587720200000001704731779519876795_);}\r\n\t.st3{clip-path:url(#SVGID_00000176030089665695015600000001032003935479342780_);}\r\n\t.st4{clip-path:url(#SVGID_00000179640183444163927310000014657373210800197556_);}\r\n\t.st5{clip-path:url(#SVGID_00000146497972305612672970000014813887678113429648_);}\r\n\t.st6{clip-path:url(#SVGID_00000041290019811518460480000007538594730401551234_);}\r\n\t.st7{clip-path:url(#SVGID_00000098909672957793102960000014651835486226112186_);}\r\n\t.st8{clip-path:url(#SVGID_00000125565904890725904830000003177355212227340444_);}\r\n\t.st9{clip-path:url(#SVGID_00000038381203546832559410000006949851411040836277_);}\r\n\t.st10{clip-path:url(#SVGID_00000018952148902196354630000007542145931252800132_);}\r\n\t.st11{clip-path:url(#SVGID_00000000922288810106552780000011914551431081847207_);}\r\n\t.st12{clip-path:url(#SVGID_00000018233484663486165970000006848642593190633883_);}\r\n\t.st13{clip-path:url(#SVGID_00000096058382597739092170000005865357001379058362_);}\r\n\t.st14{fill:#334155;}\r\n\t.st15{clip-path:url(#SVGID_00000037671792512766406430000017333269148656029625_);}\r\n\t.st16{fill:#FFFFFF;}\r\n\t.st17{clip-path:url(#SVGID_00000106133042132183489820000012482226099648582062_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M561.8,242.1c-1.6-2.1-2.5-5.2-2.5-9.1s0.8-7,2.5-9.1c3.3-3.9,9.1-4.3,13-1c0.4,0.3,0.7,0.7,1,1 c1.6,2.1,2.4,5.2,2.4,9.1s-0.8,7-2.4,9.1c-3.3,3.9-9.1,4.3-13,1C562.4,242.8,562.1,242.5,561.8,242.1 M553.6,218.2 c-6.7,8.7-6.7,20.8,0,29.6c3.3,4.1,8.4,6.2,15.2,6.2s11.9-2,15.2-6.2c6.7-8.7,6.7-20.8,0-29.6c-3.3-4.2-8.4-6.3-15.2-6.2 S556.9,214.1,553.6,218.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000134245961476140638490000015107991432808748932_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000134245961476140638490000015107991432808748932_)"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 533.6,
    y: 197,
    className: "st1",
    width: 70.4,
    height: 71.9
  })))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000011739459969372157150000000756454120232078266_",
    d: "M482.3,245.1c-1.1-1-1.6-2.4-1.5-3.8 c-0.1-1.8,0.8-3.5,2.4-4.4c1.5-0.7,3.1-1.2,4.7-1.4l2.3-0.4c0.9-0.2,1.8-0.4,2.7-0.7c0.7-0.3,1.4-0.6,2-1v3.9 c-0.1,3.5-1,5.9-2.9,7.2c-1.8,1.3-3.9,2-6.1,2C484.6,246.4,483.4,246,482.3,245.1 M474.8,217.2c-1.8,2.5-2.8,5.5-2.9,8.6h9.8 c0.2-1.3,0.7-2.6,1.5-3.6c1-1.2,2.7-1.8,5.2-1.8c1.7-0.1,3.4,0.2,5,0.9c1.2,0.7,1.8,2,1.7,3.4c0,1.4-0.9,2.6-2.2,3 c-1.3,0.5-2.7,0.8-4.1,0.9l-3.5,0.4c-3.1,0.3-6.2,1.1-9,2.6c-3.7,2.2-5.6,5.7-5.6,10.6c0,3.8,1.1,6.7,3.5,8.7s5.2,2.9,8.8,3.1 c22.2,1,22-11.9,22.2-14.6v-15c0-4.8-1.7-8-5-9.8c-3.5-1.8-7.5-2.7-11.4-2.6C482.2,212,477.5,213.7,474.8,217.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000034781365825898962030000002901772390680565149_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000011739459969372157150000000756454120232078266_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000034781365825898962030000002901772390680565149_)"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 455.7,
    y: 197,
    className: "st1",
    width: 64.4,
    height: 71.9
  })))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000009551306939020509150000005081642480687453313_",
    d: "M435.3,217.6c-3.4,3.8-5.1,9.1-5.1,15.9 c0,6,1.5,10.9,4.6,14.7c3.1,3.8,7.9,5.7,14.4,5.7c6.5,0,11.5-2.3,14.8-6.8c2-2.6,3.2-5.7,3.5-9h-10.8c-0.1,1.8-0.8,3.6-1.9,5.1 c-1,1.3-2.8,2-5.3,2c-3.2,0.2-6.2-1.9-7.2-4.9c-0.8-2.2-1.1-4.6-1-7c-0.1-2.5,0.3-5,1-7.3c1.3-3.5,3.8-5.2,7.4-5.2 c2.1-0.2,4.2,0.7,5.6,2.4c0.8,1.2,1.3,2.6,1.5,4h10.9c-0.6-5.7-2.5-9.6-5.8-11.8s-7.4-3.3-12.5-3.3 C443.4,212,438.7,213.8,435.3,217.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000105419742414136254700000003716761839740958628_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000009551306939020509150000005081642480687453313_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105419742414136254700000003716761839740958628_)"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 415.2,
    y: 197,
    className: "st1",
    width: 67.4,
    height: 71.9
  })))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000135673616432875304190000003405378521422325387_",
    d: "M406.2,232v20.4h10.2v-19.1c0-3.1,0.4-5.4,1.2-6.9 c1.4-2.7,4.1-4,8.2-4c0.3,0,0.7,0,1.2,0s1.1,0.1,1.7,0.1V212h-0.9h-0.5C404.9,212,406.3,232.1,406.2,232"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000042724100747384072960000010048900701963961508_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000135673616432875304190000003405378521422325387_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000042724100747384072960000010048900701963961508_)"
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 391.2,
    y: 197,
    className: "st1",
    width: 52.4,
    height: 70.4
  })))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000023266377444263951840000001730284614113589925_",
    d: "M376.1,222.8c1.6-1.6,3.9-2.4,6.1-2.3 c2.2-0.1,4.4,0.7,6.1,2.1c1.7,1.6,2.7,3.9,2.7,6.3h-17.7C373.6,226.6,374.6,224.5,376.1,222.8 M368.2,217.5 c-3.6,3.7-5.4,8.9-5.4,15.8c0,7.3,2,12.6,6,15.8c3.9,3.2,8.8,4.9,13.8,4.9c6.3,0,11.3-1.9,14.8-5.8c1.7-1.7,2.9-3.7,3.6-6h-11 c-0.4,0.6-0.9,1.1-1.4,1.6c-1.5,1.2-3.5,1.6-5.8,1.6c-1.9,0.1-3.8-0.3-5.5-1.3c-2.6-1.6-4-4.3-4.2-8.3h28.6c0.1-2.6,0-5.2-0.3-7.9 c-0.4-2.9-1.5-5.7-3.1-8.2c-1.7-2.6-4-4.6-6.8-5.9c-2.9-1.3-6-1.9-9.2-1.9C376.5,212,371.8,213.8,368.2,217.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000030464661898568311910000016209746444925131708_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000023266377444263951840000001730284614113589925_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000030464661898568311910000016209746444925131708_)"
    }
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 347.8,
    y: 197,
    className: "st1",
    width: 68.9,
    height: 71.9
  })))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000060020034424317742980000006956922531085329086_",
    d: "M330.7,217.4c-2.8-3.5-7-5.5-11.5-5.4 c-9.9,0-16.3,7.4-16.3,17.1v23.4h9.3v-23.6c0-4.3,2.9-7.3,7-7.3c6.1,0,6.7,5.1,6.7,7.3v23.6h9.3v-23.6c0-4.3,3-7.3,7-7.3 c6.1,0,6.8,5.1,6.8,7.3v23.6h9.3V229c0-10-6-17.1-16.1-17.1C337.7,211.9,333.4,213.9,330.7,217.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000152954909724582205570000011683074759300080041_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000060020034424317742980000006956922531085329086_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000152954909724582205570000011683074759300080041_)"
    }
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 287.9,
    y: 197,
    className: "st1",
    width: 85.4,
    height: 70.4
  })))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000093141985360867897210000008893299803907146144_",
    d: "M522.1,242.2c-1.5-2.7-2.3-5.9-2.1-9 c-0.1-3,0.6-5.9,2.1-8.4c1.3-2.3,3.8-3.6,6.5-3.4c1.9,0,3.7,0.6,5.1,1.9c2.4,2.1,3.6,5.8,3.6,10.6c0.1,3-0.7,5.9-2.2,8.4 c-1.4,2.1-3.9,3.4-6.5,3.2C525.9,245.6,523.4,244.4,522.1,242.2 M536.9,207.2v11.1c-1.1-1.8-2.6-3.3-4.4-4.3 c-1.9-1.1-4-1.6-6.2-1.6c-4.7-0.1-9.2,2-12.1,5.8c-3,3.9-4.5,9.4-4.5,16.1c0,5.8,1.5,10.6,4.6,14.3c3.1,3.7,9.1,5.3,14.4,5.3 c18.6,0,18.4-16.3,18.4-16.3V200c0,0-0.5-0.1-1.2-0.1C543.2,200,536.9,200.7,536.9,207.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000125598216478831969030000003381493367323372930_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000093141985360867897210000008893299803907146144_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000125598216478831969030000003381493367323372930_)"
    }
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 494.6,
    y: 185,
    className: "st1",
    width: 67.4,
    height: 83.9
  })))), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000075863230125289270310000013442295885983896252_",
    d: "M415.1,283.8c1.7-1.5,3.9-2.3,6.1-2.2 c2.2-0.1,4.4,0.7,6.1,2.1c1.7,1.5,2.7,3.7,2.7,6h-17.7C412.6,287.5,413.5,285.4,415.1,283.8 M407.1,278.7 c-3.6,3.5-5.4,8.6-5.4,15.2c0,7,2,12.1,6,15.3c3.9,3.1,8.8,4.8,13.8,4.7c6.3,0,11.2-1.9,14.8-5.6c1.7-1.6,2.9-3.6,3.6-5.8h-11 c-0.4,0.6-0.9,1.1-1.4,1.6c-1.7,1.2-3.8,1.7-5.9,1.6c-1.9,0.1-3.8-0.3-5.5-1.3c-2.6-1.5-3.9-4.2-4.1-8h28.6c0.1-2.5,0-5.1-0.4-7.6 c-0.4-2.8-1.5-5.5-3.1-7.9c-1.7-2.5-4-4.4-6.8-5.6c-2.9-1.2-6.1-1.8-9.2-1.8C415.4,273.4,410.7,275.2,407.1,278.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000140001337688762478520000002554801780106123430_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075863230125289270310000013442295885983896252_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000140001337688762478520000002554801780106123430_)"
    }
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 386.7,
    y: 258.4,
    className: "st1",
    width: 68.9,
    height: 70.4
  })))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000079467990604951887480000009014606391769932971_",
    d: "M349.4,302.2c-1.6-2.5-2.4-5.4-2.2-8.4 c0-4.8,1.2-8.2,3.6-10.3c1.4-1.2,3.2-1.9,5.1-1.9c2.6-0.2,5.1,1.1,6.5,3.4c1.5,2.6,2.2,5.5,2.1,8.5c0.1,3-0.6,6.1-2.1,8.7 c-1.4,2.2-3.8,3.4-6.4,3.2C353.4,305.6,350.9,304.3,349.4,302.2 M337.3,267.4v30.1c0,0-0.2,16.3,18.4,16.3 c5.3,0,11.4-1.6,14.4-5.3c3.1-3.7,4.6-8.5,4.6-14.3c0-6.7-1.5-12-4.5-15.8c-2.9-3.8-7.4-5.9-12.1-5.8c-2.2,0-4.3,0.5-6.2,1.6 c-1.8,1.1-3.3,2.6-4.4,4.4V260c-0.3,0-0.7,0-1,0C343.9,260,337.3,260.6,337.3,267.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062895538816050927730000002327066346337884859_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000079467990604951887480000009014606391769932971_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000062895538816050927730000002327066346337884859_)"
    }
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 322.3,
    y: 244.9,
    className: "st1",
    width: 67.4,
    height: 83.9
  })))), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000033334080838246919320000005223030685609241753_",
    d: "M377.8,292.1v20.2H388v-19c0-3.2,0.4-5.5,1.2-7 c1.4-2.7,4.1-4,8.2-4c0.3,0,0.7,0,1.2,0s1.1,0.1,1.7,0.1V272l-0.9-0.1h-0.5C376.5,271.9,377.8,292.2,377.8,292.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000087373320317461309500000002322778456217652126_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000033334080838246919320000005223030685609241753_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000087373320317461309500000002322778456217652126_)"
    }
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 362.8,
    y: 256.9,
    className: "st1",
    width: 52.4,
    height: 70.4
  })))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000123413986419087773370000007057251967492309389_",
    d: "M302.9,267.3v45.1h9v-52.4h-0.2 C310.3,259.9,302.9,260.2,302.9,267.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142887404130760409140000008300257093182655144_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000123413986419087773370000007057251967492309389_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000142887404130760409140000008300257093182655144_)"
    }
  }, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 287.9,
    y: 244.9,
    className: "st1",
    width: 38.9,
    height: 82.4
  })))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 319.3,
    y: 259.9,
    className: "st1",
    width: 10.5,
    height: 10.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 319.3,
    y: 273.4,
    className: "st1",
    width: 10.5,
    height: 39
  })), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000003801746183987948520000005743078069888915633_",
    d: "M184.5,194c-50.1,0.1-90.6,27-90.4,59.8v3.5 c0.1,34.8,35.6,62.9,90.8,62.6c55.5-0.1,90.5-28.5,90.5-63.2c-0.1-1.2,0-1.9,0-3.5c-0.2-32.6-40.6-59.2-90.5-59.2H184.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000054976523819379675770000016423470079322947261_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003801746183987948520000005743078069888915633_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000054976523819379675770000016423470079322947261_)"
    }
  }, _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 179.1,
    className: "st1",
    width: 211.3,
    height: 155.9
  })))), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000087401803050427460670000015035061130059004033_",
    d: "M184.5,197.2c-47.7,0.1-86.3,25.5-86.2,56.7 s38.8,56.4,86.5,56.2s86.3-25.5,86.2-56.7s-38.6-56.2-86.1-56.2H184.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062163980249257249260000009405826973988158851_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000087401803050427460670000015035061130059004033_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000062163980249257249260000009405826973988158851_)"
    }
  }, _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 83.3,
    y: 182.2,
    className: "st14",
    width: 202.7,
    height: 142.9
  })))), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000020377901541786066030000011851596178515557518_",
    d: "M143.4,260.1c-3.4,0.1-6,3-5.9,6.4 c0.1,3.2,2.7,5.7,5.9,5.9c1.6,0,3.1-0.7,4.2-1.8c0.1,0,0.1,0.1,0,0.2c0,0,0,0,0,0c-0.3,1.5-0.7,7,5,9.2c2,0.8,4.3,0.4,5.9-1 c0.5-0.4,0.6-0.2,0.5,0.3c-0.2,1.4,0.1,4.5,4.3,6.1c2.2,1,4.8,0.5,6.4-1.2c0.6-0.5,0.7-0.4,0.8,0.4c0.1,4.2,3.6,7.5,7.8,7.4 c4.2-0.1,7.5-3.6,7.4-7.8l0,0c-0.1-4.2-3.5-7.6-7.7-7.6c-1.7,0-3.6,1-3.9,0.9c0-0.4,0.1-0.8,0.3-1.2c0.2-0.4,2.4-7.3-3.1-9.6 c-4.3-1.8-6.9,0.3-7.7,1.1c-0.3,0.3-0.4,0.2-0.4-0.1c-0.1-2.6-1.8-4.9-4.3-5.7c-3.6-1.1-7.4,0.3-9.5,3.4c-0.3-3-2.9-5.3-5.9-5.3 H143.4z M98.1,246.9c1.6,0.5,4.1,1.2,5.2,1.4c24.8,5.5,32.6,11.1,33.9,12.3c1.5-1.8,3.8-2.8,6.1-2.8c2.7,0,5.2,1.3,6.7,3.5 c1.7-1.4,3.8-2.1,5.9-2.1c1.2,0,2.4,0.2,3.6,0.6c2.3,0.6,4.1,2.3,5,4.5c1.1-0.5,2.3-0.7,3.5-0.7c1.4,0,2.8,0.3,4.1,0.9 c4.6,1.9,5.3,6.5,4.9,9.9c0.3,0,0.6,0,0.9,0c5.4,0,9.8,4.4,9.8,9.8c0,1.6-0.4,3.2-1.2,4.7c1.5,0.8,5.2,2.7,8.5,2.3 c2.6-0.3,3.7-1.3,4-1.8c0.3-0.5,0.5-0.8,0.3-1l-7-7.8c0,0-1.1-1.1-0.8-1.5c0.4-0.4,1.1,0.2,1.6,0.6c3.5,3,7.9,7.5,7.9,7.5 s0.4,0.7,2,0.9c1.9,0.3,3.9-0.1,5.6-1.3c0.4-0.4,0.9-0.8,1.2-1.2l-0.1,0.1c1.8-2.3-0.2-4.6-0.2-4.6l-8.2-9.2c0,0-1.1-1.1-0.8-1.5 c0.4-0.4,1.1,0.2,1.6,0.6c2.6,2.1,6.3,5.8,9.7,9.2c0.7,0.5,3.8,2.4,7.8-0.3c2.4-1.6,3-3.6,2.9-5.2c-0.2-1.3-0.8-2.5-1.7-3.4 l-11.2-11.2c0,0-1.1-1-0.8-1.5c0.4-0.5,1.1,0.2,1.6,0.6c3.5,3,13.2,11.8,13.2,11.8c2.3,1.5,5.3,1.4,7.6-0.2c1.4-0.8,2.4-2.3,2.5-4 c0.1-1.7-0.6-3.4-1.9-4.6c-0.3-0.3-28.3-24.7-34.6-29.5c-3.7-2.7-5.7-3.4-7.9-3.7c-1.3-0.1-2.5,0-3.8,0.3 c-2.9,0.8-6.8,3.4-10.2,6.1c-3.6,2.9-6.8,5.5-9.9,6.2c-4,0.9-8.8-0.2-11-1.7c-0.8-0.5-1.4-1.2-1.8-2c-0.8-1.9,0.7-3.4,0.9-3.7 l7.7-8.4c0.9-0.9,1.8-1.8,2.7-2.7c-2.4,0.4-4.7,0.9-7,1.6c-2.6,0.9-5.4,1.4-8.2,1.5c-2.8-0.3-5.6-0.7-8.4-1.3 c-7.7-2-15.1-4.6-22.3-7.9C107.4,225.3,100.1,235.6,98.1,246.9 M188,215.6c-13.1,0.4-18.8,6-24.7,12.1l-7.6,8.3 c0,0.1-0.9,1-0.4,1.7c1.3,1.8,5.6,2.8,9.9,1.8c2.5-0.6,5.8-3.2,9-5.8c3.5-2.8,6.8-5.5,10.3-6.6c2.4-0.9,5.1-1,7.5-0.2 c2.5,0.9,4.8,2.3,6.8,4c6,4.5,30,25.5,34.2,29c12.3-5.4,25.2-9.6,38.3-12.5c-1.8-10.8-8.4-20.6-18.3-28.6 c-13.8,5.9-30.7,9-47.2,0.9c-0.1,0-8.6-4-17.2-4L188,215.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178912027527334394710000004290476071475470488_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000020377901541786066030000011851596178515557518_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178912027527334394710000004290476071475470488_)"
    }
  }, _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 83.1,
    y: 200.6,
    className: "st16",
    width: 203.2,
    height: 106.3
  })))), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000159427614132171958390000008348701213203597446_",
    d: "M138,266.5c-0.1-3,2.3-5.6,5.3-5.6 c2.9-0.1,5.3,2.1,5.6,4.9l0.2,1.5l0.8-1.2c1.5-2.2,3.9-3.5,6.5-3.6c0.8,0,1.6,0.1,2.4,0.3c2.3,0.7,3.8,2.8,3.9,5.2 c0.1,0.8,0.6,0.8,0.7,0.8c0.2,0,0.5-0.1,0.7-0.3c1-1.1,2.5-1.7,4-1.8c1,0,2.1,0.3,3,0.7c5.2,2.2,2.9,8.9,2.9,9 c-0.5,1.1-0.5,1.6-0.1,1.9l0.2,0.1h0.2c0.3-0.1,0.7-0.2,1-0.3c0.9-0.4,1.9-0.6,2.8-0.6c3.9,0,7,3.1,7,7c0,3.9-3.1,7-7,7 c-3.8,0-7-3-7.2-6.8c0-0.3,0-1.2-0.8-1.2c-0.3,0-0.6,0.2-0.8,0.5c-0.9,1-2.1,1.6-3.5,1.6c-0.8,0-1.6-0.2-2.3-0.5 c-4.1-1.7-4.1-4.4-3.9-5.5c0.1-0.3,0.1-0.6-0.1-0.8l-0.3-0.2H159c-0.2,0-0.5,0.1-0.6,0.3c-1,0.8-2.2,1.3-3.5,1.3 c-0.6,0-1.3-0.1-1.9-0.4c-5.3-2.1-4.9-7.1-4.6-8.7c0-0.3,0-0.6-0.2-0.7l-0.4-0.3l-0.4,0.4c-1,1-2.4,1.6-3.8,1.5l0,0 C140.5,271.9,138.1,269.5,138,266.5 M188.8,212.7H188c-10.9,0.3-17,4.2-21.1,7.5c-3.6,0.2-7.1,0.9-10.5,1.9 c-2.4,0.8-4.9,1.3-7.4,1.4c-0.5,0-1.2,0-1.8,0h-1.1c-2.6-0.1-16-3.3-26.6-7.3c-1.1,0.8-2.2,1.6-3.2,2.4c11.1,4.5,24.7,8,28.9,8.2 l3.7,0.2c2.9-0.2,5.7-0.7,8.4-1.6c1.7-0.5,3.5-1,5.3-1.3c-0.5,0.5-1,1-1.5,1.5l-7.7,8.3c-0.6,0.6-2,2.3-1.1,4.3 c0.5,0.9,1.1,1.7,2,2.2c2.5,1.4,5.3,2.1,8.2,2.1c1.1,0,2.2-0.1,3.3-0.3c3.2-0.7,6.6-3.5,10.2-6.3c2.8-2.3,6.9-5.2,10-6.1 c0.9-0.2,1.9-0.4,2.8-0.4c0.3,0,0.5,0,0.8,0.1c2.1,0.3,4.1,1,7.6,3.6c6.3,4.8,34.4,29.2,34.6,29.4c1.1,1.1,1.7,2.6,1.7,4.1 c-0.1,1.5-0.9,2.8-2.2,3.6c-1.1,0.7-2.4,1.1-3.7,1.2c-1.1,0-2.3-0.3-3.2-0.9c-0.1-0.1-9.7-8.9-13.3-11.8c-0.5-0.4-1-0.7-1.6-0.9 c-0.3,0-0.6,0.1-0.8,0.4c-0.6,0.7,0.1,1.6,0.8,2.3l11.2,11.2c0.8,0.8,1.4,1.9,1.6,3c0.1,1.9-0.8,3.4-2.7,4.7 c-1.2,0.9-2.6,1.3-4,1.3c-1.1,0-2.3-0.4-3.2-1l-1.6-1.6c-3-2.9-6-5.9-8.2-7.8c-0.5-0.5-1.1-0.8-1.7-0.8c-0.3,0-0.5,0.1-0.7,0.3 c-0.3,0.3-0.5,0.8,0.2,1.6c0.2,0.2,0.4,0.5,0.6,0.7l8.2,9.2c1,1.1,1.1,2.7,0.2,3.9l-0.3,0.4l-0.7,0.8c-1.2,0.9-2.6,1.3-4,1.3 c-0.4,0-0.8,0-1.1-0.1c-0.6-0.1-1.1-0.3-1.6-0.6l-0.1-0.1c-0.5-0.5-4.6-4.7-8-7.5c-0.4-0.4-1-0.7-1.6-0.8c-0.3,0-0.6,0.1-0.8,0.3 c-0.7,0.8,0.3,1.9,0.8,2.3l7,7.7c0,0.1-0.1,0.2-0.3,0.5c-0.2,0.3-1.1,1.1-3.6,1.6c-0.3,0-0.7,0.1-1,0.1c-2.4-0.1-4.7-0.8-6.8-2 c0.7-1.4,1-2.9,1-4.5c0-5.7-4.5-10.3-10.2-10.4c0,0-0.1,0-0.1,0h-0.4c0.2-2.6-0.2-7.6-5.3-9.8c-1.4-0.6-2.9-0.9-4.4-1 c-1.1,0-2.2,0.2-3.2,0.6c-1-2.1-2.9-3.6-5.1-4.3c-1.2-0.4-2.4-0.6-3.7-0.6c-2.1,0-4.1,0.7-5.8,1.9c-1.7-2.1-4.2-3.3-6.8-3.3 c-2.3,0-4.6,1-6.2,2.6c-2.2-1.7-10.8-7.1-33.9-12.3c-1.1-0.3-3.7-1-5.2-1.4c-0.3,1.2-0.4,2.5-0.6,3.8c0,0,4.3,1,5.1,1.2 c23.6,5.2,31.3,10.6,32.6,11.6c-0.4,1.1-0.7,2.2-0.7,3.4c0.1,5,4.2,8.9,9.2,8.8c0.4,0,0.8,0,1.2-0.1c0.7,3.6,3.3,6.5,6.7,7.7 c1,0.4,2.1,0.6,3.1,0.6c0.7,0,1.3-0.1,2-0.2c1,2.4,3,4.3,5.4,5.1c1.1,0.5,2.3,0.7,3.5,0.7c0.9,0,1.9-0.2,2.7-0.5 c1.6,3.9,5.4,6.4,9.6,6.4c2.8,0,5.5-1.2,7.4-3.2c2.7,1.5,5.7,2.4,8.8,2.6c0.4,0,0.9,0,1.3-0.1c3.6-0.4,5.2-1.9,5.9-2.9 c0.1-0.2,0.3-0.4,0.4-0.6c0.9,0.3,1.9,0.5,2.8,0.4c2.1-0.1,4-0.8,5.6-2.1c1.7-1.1,2.9-2.9,3.3-4.9v-0.1c0.6,0.1,1.2,0.2,1.9,0.2 c2.1,0,4.1-0.7,5.8-1.9c3.7-2.4,4.3-5.5,4.2-7.5c0.6,0.1,1.3,0.2,1.9,0.2c1.9-0.1,3.8-0.6,5.5-1.7c2.2-1.4,3.6-3.7,3.8-6.2 c0.1-1.7-0.3-3.5-1.2-5c11.8-4.8,23.9-8.7,36.2-11.5c-0.1-1.2-0.3-2.6-0.5-3.8c-13,2.9-25.7,7-37.8,12.4 c-8.6-7.5-28.6-24.8-34-28.8c-2.1-1.8-4.4-3.1-7-4.1c-1.1-0.4-2.2-0.5-3.4-0.5c-1.5,0-2.9,0.3-4.3,0.7c-3.5,1.1-7,3.9-10.3,6.6 l-0.2,0.1c-3.1,2.5-6.4,5.1-8.8,5.6c-1.1,0.2-2.2,0.4-3.3,0.4c-2.7,0-5.2-0.8-6.2-1.9c-0.2-0.2-0.1-0.5,0.3-1l0.1-0.1l7.6-8.2 c5.9-5.9,11.5-11.6,24.4-11.9h0.7c8,0,16.1,3.6,17,3.9c7.2,3.6,15.1,5.5,23.1,5.5c8.1,0,16.5-2.1,25.4-6.2c-1-0.8-2-1.7-3.1-2.4 c-7,3.2-14.6,5-22.3,5.1c-7.5-0.1-14.9-1.8-21.7-5.1c-0.4-0.2-9.2-4.3-18.4-4.3L188.8,212.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000063597951960425072120000003642833123798097290_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000159427614132171958390000008348701213203597446_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000063597951960425072120000003642833123798097290_)"
    }
  }, _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 82.5,
    y: 197.7,
    className: "st1",
    width: 204.3,
    height: 112.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMercadolibre);
export default __webpack_public_path__ + "static/media/mercadolibre.eaaf4a222f6fcdaae43b2357c1bf7666.svg";
export { ForwardRef as ReactComponent };